import React from 'react';

import Text from '~components/atoms/Text';
import CustomSkeleton from '~components/atoms/Skeleton';

import { useAppSelector } from '~redux/hooks';
import { FundTypeEnum, SilverTypeEnum } from '~utils/enums';

import * as Styles from './_physicalSilverTable.module.scss';
import { TDashboardProductInventory } from '~types/feat/dashboard';

const PhysicalSilverTable = () => {
    const dashboardSilverProductInventory = useAppSelector(state => state.dashboard.dashboardSilverProductInventory);
    const loading = useAppSelector(state => state.dashboard.loadings.getDashboardProductInventory);
    const error = useAppSelector(state => state.dashboard.errors.getDashboardProductInventory);

    const filters = useAppSelector(state => state.dashboard.dashboardSilverProductInventoryFilters);

    const tableHeader = [
        'Denomination',
        'Quantity (pcs)',
        'Total Weight (gram)',
    ];

    const physicalSilverInventory = dashboardSilverProductInventory.filter(product => product.silverType === SilverTypeEnum.PhysicalSilver && product.fundType === FundTypeEnum.Islamic);

    const massagedInventory = physicalSilverInventory.reduce<Map<number, TDashboardProductInventory>>((acc, product) => {
        const key = product.productId;
        if (acc.has(key)) {
            const existingProduct = acc.get(key)!;
            existingProduct.amount += product.amount;
            existingProduct.totalSilverWeight += product.totalSilverWeight;
        } else {
            acc.set(key, { ...product });
        }
        return acc;
    }, new Map());

    // Convert the Map back to an array
    const combinedInventory: TDashboardProductInventory[] = Array.from(massagedInventory.values());

    const renderTableHeader = () => {
        return tableHeader.map((header, index) => {
            return (
                <th key={index}>
                    {header}
                </th>
            );
        });
    };

    const renderTableBody = () => {
        if (loading) {
            return (
                <tr>
                    <td colSpan={3}>
                        <CustomSkeleton height={40} />
                    </td>
                </tr>
            );
        }

        if (error) {
            return (
                <tr>
                    <td colSpan={3}>
                        <Text
                            label={error}
                            isError
                        />
                    </td>
                </tr>
            );
        }

        if (!physicalSilverInventory.length) {
            return (
                <tr>
                    <td colSpan={3}>
                        <Text
                            label='No data found'
                            isError
                        />
                    </td>
                </tr>
            );
        }

        if (filters.branchCode === '') {
            return combinedInventory.sort((a, b) => a.productId - b.productId).map((product, index) => {
                return (
                    <tr key={index}>
                        <td>{product.productName}</td>
                        <td>{product.amount}</td>
                        <td>{typeof product.totalSilverWeight === 'number' ? product.totalSilverWeight.toFixed(3) : '-'}</td>
                    </tr>
                );
            });
        }

        return physicalSilverInventory.sort((a, b) => a.productId - b.productId).map((product, index) => {
            return (
                <tr key={index}>
                    <td>{product.productName}</td>
                    <td>{product.amount}</td>
                    <td>{typeof product.totalSilverWeight === 'number' ? product.totalSilverWeight.toFixed(3) : '-'}</td>
                </tr>
            );
        });
    };

    return (
        <div className={Styles.container}>
            <Text
                label='Affin Silver-I'
                className={Styles.title}
                isBold
            />

            <table className={Styles['table-container']}>
                <thead>
                    <tr>
                        {renderTableHeader()}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colSpan={3} />
                    </tr>
                    {renderTableBody()}
                </tbody>
            </table>
        </div>
    );
};

export default PhysicalSilverTable;
